module.exports = __webpack_public_path__ + "img/c60.55809dfa.png";